export function UsFlag({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 3 2"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <rect width="3" height="2" fill="#012169" />
      <path
        d="M0,0 L3,2 M3,0 L0,2"
        stroke="#fff"
        strokeWidth="0.2"
        strokeLinecap="square"
      />
      <path
        d="M0,0 L3,2 M3,0 L0,2"
        stroke="#C8102E"
        strokeWidth="0.125"
        strokeLinecap="square"
      />
      <path
        d="M1.5,0 v2 M0,1 h3"
        stroke="#fff"
        strokeWidth="0.267"
      />
      <path
        d="M1.5,0 v2 M0,1 h3"
        stroke="#C8102E"
        strokeWidth="0.16"
      />
    </svg>
  )
}
